(() => {
  "use strict";

  const destinations = {
    ys16_12: "/products/ys16-1-max-heavy-duty-wide-seat-power-wheelchair-12ah",
    ys16_20: "/products/anywell-ys16-max-wide-seat-electric-wheelchair-20ah",
    ys12: "/products/anywell-ys12-15-plus-folding-electric-wheelchair",
    ya12: "/products/anywell-ya12-5-long-range-durable-electric-wheelchair",
    x024: "/products/anywell-x-024-wide-seat-electric-mobility-scooter",
    footrests: "/products/ys16-1-plus-electric-wheelchair-a-pair-of-footrests",
    rear_wheel: "/products/16-1-plus-electric-wheelchair-rear-wheel-tire-and-inner-tube-set",
    front_fork: "/products/16-1-plus-electric-wheelchair-replacement-part-front-fork-and-suspension-spring-set"
  };

  const clean = (value) => String(value || "").toLowerCase().replace(/[_–—]+/g, "-").replace(/\s+/g, " ");
  const includesProductPath = (href) => /\/products\//.test(href || "");

  function resolveProduct(image) {
    const card = image.closest("[data-product-handle], article, li, figure");
    const handle = card?.getAttribute("data-product-handle") || "";
    const context = clean([image.currentSrc || image.src, image.alt, handle, card?.textContent?.slice(0, 320)].join(" "));

    if (/ys16-1-plus-electric-wheelchair-a-pair-of-footrests|(?:(?:replacement|part|pair|set).{0,70}foot\s*rests?.{0,70}16-1)|(?:16-1.{0,70}(?:replacement|part|pair|set).{0,70}foot\s*rests?)/.test(context)) {
      return { key: "footrests", href: destinations.footrests, label: "View YS16 footrests", variant: null };
    }
    if (/16-1-plus-electric-wheelchair-rear-wheel-tire|(?:16-1.{0,70}(?:replacement|part|set).{0,70}rear wheel.{0,35}(?:tire|tube))/.test(context)) {
      return { key: "rear_wheel", href: destinations.rear_wheel, label: "View YS16 rear wheel set", variant: null };
    }
    if (/16-1-plus-electric-wheelchair-replacement-part-front-fork|(?:16-1.{0,70}(?:replacement|part|set).{0,70}front fork)/.test(context)) {
      return { key: "front_fork", href: destinations.front_fork, label: "View YS16 front fork set", variant: null };
    }

    const ys16 = /ys16|ys-16|16-1 max/.test(context);
    if (ys16 && /20\s*ah|20ah/.test(context)) {
      return { key: "ys16_20", href: destinations.ys16_20, label: "View YS16-1 MAX 20Ah", variant: "20Ah" };
    }
    if (ys16 && /12\s*ah|12ah/.test(context)) {
      return { key: "ys16_12", href: destinations.ys16_12, label: "View YS16-1 MAX 12Ah", variant: "12Ah" };
    }
    if (ys16) {
      return { key: "ys16_family", href: destinations.ys16_20, label: "View YS16-1 MAX 20Ah; 12Ah Standard option also available", variant: "12Ah / 20Ah" };
    }
    if (/ys12-15|ys12 15|ys12_15/.test(context)) {
      return { key: "ys12", href: destinations.ys12, label: "View YS12-15 PLUS", variant: null };
    }
    if (/ya12-5|ya12 5|ya12_5/.test(context)) {
      return { key: "ya12", href: destinations.ya12, label: "View YA12-5", variant: null };
    }
    if (/x-024|x024|x_024/.test(context)) {
      return { key: "x024", href: destinations.x024, label: "View X-024 mobility scooter", variant: null };
    }
    return null;
  }

  function addVariantBadge(link, product) {
    if (!product.variant || link.querySelector(":scope > .anywell-product-image-variant-badge")) return;
    const badge = document.createElement("span");
    badge.className = "anywell-product-image-variant-badge";
    badge.textContent = product.variant;
    badge.setAttribute("aria-hidden", "true");
    link.append(badge);
  }

  function enhanceImage(image) {
    if (!(image instanceof HTMLImageElement) || image.dataset.anywellProductLinkReviewed === "true") return;
    image.dataset.anywellProductLinkReviewed = "true";
    if (image.closest("button, [role='button'], .product-gallery, product-gallery")) return;
    const product = resolveProduct(image);
    if (!product) return;

    let link = image.closest("a");
    if (link && includesProductPath(link.getAttribute("href"))) {
      link.classList.add("anywell-product-image-link");
      link.dataset.anywellProductKey = product.key;
      addVariantBadge(link, product);
      return;
    }

    if (link) {
      link.href = product.href;
      link.setAttribute("aria-label", product.label);
      link.classList.add("anywell-product-image-link");
      link.dataset.anywellProductKey = product.key;
      addVariantBadge(link, product);
      return;
    }

    const media = image.closest("picture") || image;
    if (media.parentElement?.closest("a")) return;
    link = document.createElement("a");
    link.href = product.href;
    link.className = "anywell-product-image-link";
    link.dataset.anywellProductKey = product.key;
    link.setAttribute("aria-label", product.label);
    media.replaceWith(link);
    link.append(media);
    addVariantBadge(link, product);
  }

  function scan(root = document) {
    if (root instanceof HTMLImageElement) enhanceImage(root);
    root.querySelectorAll?.("main img").forEach(enhanceImage);
  }

  let queued = false;
  const observer = new MutationObserver((mutations) => {
    if (queued || !mutations.some((mutation) => mutation.addedNodes.length)) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      scan(document);
    });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => scan(document), { once: true });
  } else {
    scan(document);
  }
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
